<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-12">
          <v-form action="#" @submit.prevent="submit">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Login</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-alert v-if="error" type="error">{{error}}</v-alert>
              <v-text-field
                label="Login"
                name="login"
                prepend-icon="person"
                type="text"
                v-model="form.email"
              />
              <v-text-field
                id="password"
                label="Password"
                name="password"
                prepend-icon="lock"
                type="password"
                v-model="form.password"
              />
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="primary" type="submit">Login</v-btn>
          </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import firebase from 'firebase';
  import { mapActions, mapGetters } from 'vuex';

  export default {
    data() {
      return {
        form: {
          email: '',
          password: ''
        },
        error: null
      };
    },
    computed: {
      ...mapGetters({
        user: "user"
      })
    },
    methods: {
      ...mapActions({
        fetchUser: 'fetchUser'
      }),
      submit() {
        firebase
          .auth()
          .signInWithEmailAndPassword(this.form.email, this.form.password)
          .then(data => {
            this.fetchUser(data.user);
            this.$router.replace({ name: 'home' });
          })
          .catch(err => {
            this.error = err.message;
          });
      }
    }
  };
</script>
